import type { ModelResponse, ModelProfileText } from '../shared/types/Model'
import type { Mode } from '../shared/types/Mode'

export function applyModelProfile(
  model: ModelResponse,
  mode: Mode = 'realism',
  language?: string | null,
): ModelResponse {
  if (mode === 'realism') return model

  const profile = resolveProfile(model, mode, language)
  if (!profile) return model

  return {
    ...model,
    name: profile.name?.trim() || model.name,
    description: profile.description?.trim() || model.description,
    character: profile.character?.trim() || model.character,
    interests: profile.interests?.trim() || model.interests,
    profession: profile.profession?.trim() || model.profession,
    age: profile.age || model.age,
    location: profile.location?.trim() || model.location,
    skills: profile.skills?.trim() || model.skills,
  }
}

function resolveProfile(model: ModelResponse, mode: Mode, language?: string | null): ModelProfileText | undefined {
  const group = model.profiles?.[mode]
  if (!group) return undefined

  const languageKey = language?.trim().toLowerCase().startsWith('ru') ? 'ru' : 'en'
  return group[languageKey] ?? group.en ?? group.ru ?? Object.values(group)[0]
}
